import { BlogPage } from '@/blog/domain/BlogPage';
import { PostRepository } from '@/blog/domain/PostRepository';
import { PostFilters } from '@/blog/infrastructure/types/PostFilters';
import { UseCase } from '@/shared/application/UseCase';
import { ServicesApiResponse } from '@hfc/ui-core';

export class GetBlogPageUseCase implements UseCase<PostFilters, ServicesApiResponse<BlogPage>> {

  private repository: PostRepository;

  public constructor (repository: PostRepository) {
    this.repository = repository;
  }

  public async run (filters: PostFilters): Promise<ServicesApiResponse<BlogPage>> {
    return await this.repository.getBlogPage(filters);
  }

}
